(() => {
  if (window.bnV3CardQuickAddReady) return;
  window.bnV3CardQuickAddReady = true;

  const itemSelector = '.bn-v3-best-sellers__item, .bn-v3-build-time__item';
  let activeItem;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.quick-add__submit');
      if (!button) return;
      const item = button.closest(itemSelector);
      if (!item) return;
      activeItem = item;
    },
    true
  );

  const restoreOnNextInteraction = (item) => {
    let redirectingFocus = false;

    const cleanup = () => {
      item.removeEventListener('pointermove', restore);
      item.removeEventListener('pointerdown', restore);
      item.removeEventListener('focusin', handleFocusIn);
    };

    const restore = () => {
      item.classList.remove('is-quick-add-dismissed');
      cleanup();
    };

    const handleFocusIn = (event) => {
      if (redirectingFocus) {
        redirectingFocus = false;
        return;
      }

      const returnedFromCart = event.relatedTarget?.closest?.('cart-drawer, cart-notification');
      if (!returnedFromCart) {
        restore();
        return;
      }

      const visibleCardLink = item.querySelector('.card__heading a');
      if (visibleCardLink) {
        redirectingFocus = true;
        requestAnimationFrame(() => visibleCardLink.focus());
      } else {
        event.target.blur();
      }
    };

    item.addEventListener('pointermove', restore);
    item.addEventListener('pointerdown', restore);
    item.addEventListener('focusin', handleFocusIn);
  };

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form' || !activeItem?.isConnected) return;

    const item = activeItem;
    activeItem = undefined;
    item.classList.add('is-quick-add-dismissed');
    item.querySelector('.quick-add__submit')?.blur();
    restoreOnNextInteraction(item);
  });

  subscribe(PUB_SUB_EVENTS.cartError, () => {
    activeItem = undefined;
  });

  document.body.addEventListener('modalClosed', () => {
    activeItem = undefined;
  });
})();
